import React from 'react'
import PropTypes from 'prop-types'
import styled from 'styled-components'

const Segment = styled.div`
    text-align: ${props => 
        props.centered 
        ? 'center'
        : 'left'
    };
    box-shadow: ${props => props.shadow
        ? '0px 0px 25px 0px #3b4545'
        : 'none'
    };
    margin-right: ${props => props.sheet
        ? '15%'
        : '0'
    };
    z-index: ${props => props.shadow 
        ? 2
        : 1
    };
    position: relative;
    font-family: ${props => props.theme.font_body};
    font-weight: ${props => props.theme.font_weight_standard};
    font-size: 16pt;
    line-height: 1.65em;
    padding: 3em 0 ${props => props.theme.element_margin} 0;
    background-color: ${props => props.noback
        ? 'none'
        : props.dark
            ? props.theme.bg_dark
            : props.theme.bg_light
    };
    color: ${props => 
        props.dark
        ? props.theme.font_light
        : props.theme.font_dark
    };
    background-attachment: fixed;
    background-image: url(${props =>
        props.overlay
        ? props.overlay
        : ''
    });
    background-size: cover;
    .background {
        position: absolute;
        top: 0;
        left: 0;
        height: 100%;
        width: 100%;
        display: block;
        object-fit: cover;
    }
    .inner {
        opacity: 1;
        position: relative;

        .actions {
            opacity: 1;
        }
    }
    @media screen and (max-width: 980px){
        margin-right: 0;
    }
`

export { Segment }


// WEBPACK FOOTER //
// ./src/components/segment.js